import React, { Component } from 'react';
import { GetMarkAsReviewedHistoryList } from '../../../../appRedux/actions/IncomeStatementAction'
import { bindActionCreators } from 'redux';
import CircularProgress from '../../../../components/CircularProgress';
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Button from '@material-ui/core/Button';
import './style.css';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { GetLastQuarterEndDate } from '../../../common/commonServices';

class IncomeStatementReviewedHistoryList extends Component {
    constructor(props) {
        super(props);

        this.sDateRef = React.createRef();
        this.eDateRef = React.createRef();
        let endDate = new Date();
        //let fromDate = new Date(endDate.getFullYear() - 1, 0, 1);
        const fromDate = new Date(endDate.getFullYear(), 0, 1);

        this.state = {            
            sDate: fromDate,
            eDate: endDate,
            ACMethod: 'Accrual',
            historyList: [],
            loading: true,
            companyId: 0,
            reportDate: null,
            reviewedDate: null
        };
    }

    componentDidMount() {
        let user = JSON.parse(localStorage.getItem('userData'));
        this.setState({ loading: true, companyId: user.companyId }, () => {
            this.loadReviewHistoryData()
        });
    }

    loadReviewHistoryData = () => {
        const { companyId, sDate, eDate, ACMethod } = this.state;

        const body = {
            CompanyID: companyId,
            AccountingMethod: ACMethod,
            FromDate: moment(sDate).format("MM/DD/YYYY"),
            ToDate: moment(eDate).format("MM/DD/YYYY")
        };
        this.setState({ loading: true });
        this.props.GetMarkAsReviewedHistoryList(body);
    }

    componentDidUpdate(prevProps) {
        if (this.props.MarkAsReviewedListData !== prevProps.MarkAsReviewedListData) {
            const data = this.props.MarkAsReviewedListData && this.props.MarkAsReviewedListData.returnObject;
            if (data) {
                this.setState({ loading: false, historyList: data });
            } else {
                this.setState({ loading: false }, () => { toast.error(this.props.MarkAsReviewedListData ? this.props.MarkAsReviewedListData.resultMsg : 'No data found') });
            }
        }
    }

    ApplyDate = () => {
        this.loadReviewHistoryData();
    }

    //Used for Datepicker
    handleFocus = (e, selecter) => {
        let control = null;
        if (selecter !== undefined) {
            control = this.eDateRef;
            if (control.current != null) {
                control.current.setFocus();
            }
        }
    }

    //Used for Datepicker
    handleDateChange = (e, target) => {
        if (target === "fromDate") {
            this.setState({ sDate: new Date(e), selectedDateRange: { startDate: moment(new Date(e)).format("MM/DD/YYYY"), endDate: moment(this.state.eDate).format("MM/DD/YYYY") } })
        }
        else if (target === "uptoDate") {
            this.setState({ eDate: new Date(e), selectedDateRange: { startDate: moment(this.state.sDate).format("MM/DD/YYYY"), endDate: moment(new Date(e)).format("MM/DD/YYYY") } })
        }
    }

    BackToReport = () => {
        this.props.history.push("incomeStatementReview");
    }

    render() {
        const { historyList, loading } = this.state;

        return (
            <div className="income-statement-history-page">
                <div className="page-heading page-title-box d-sm-flex justify-content-sm-between align-items-sm-center">
                    <h2 className="title mb-sm-0 income-statement-history-title">{JSON.parse(localStorage.getItem('userData')) != null ? JSON.parse(localStorage.getItem('userData')).companyName : ""} | Income Statement Review History</h2>
                </div>
                <div className="padding-box app-wrapper padding-b0">
                    <div className="row">
                        <div className="col-md-3">
                            <div className="select-quater-box">
                                <p className="sub-title">Reviewed Income Statements</p>
                                <div className="row">
                                    <div className="col-sm-4 col-md-12 ">
                                        <div className="datepicker-box">
                                            <div className="date-box">
                                                <DatePicker
                                                    selected={this.state.sDate}
                                                    onChange={(e) => this.handleDateChange(e, 'fromDate')}
                                                    name="fromDate"
                                                    id="date"
                                                    required={true}
                                                    margin="normal"
                                                    disabledKeyboardNavigation
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    yearDropdownItemNumber={15}
                                                    popperModifiers={{
                                                        preventOverflow: { enabled: true, boundariesElement: 'viewport' },
                                                        flip: { enabled: true }
                                                    }}
                                                    maxDate={this.state.eDate}
                                                    ref={this.sDateRef}
                                                />
                                                <div className="date-icon" onClick={(e) => this.handleFocus(e, 'sDate')}>
                                                    <i className="zmdi zmdi-calendar-note"></i>
                                                </div>
                                            </div>
                                            <div className="to-box">
                                                <span className="text-center ledgerto-text">To</span>
                                            </div>
                                            <div className="date-box">
                                                <DatePicker
                                                    selected={this.state.eDate}
                                                    onChange={(e) => this.handleDateChange(e, 'uptoDate')}
                                                    name="uptoDate"
                                                    id="date"
                                                    required={true}
                                                    margin="normal"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    yearDropdownItemNumber={15}
                                                    disabledKeyboardNavigation
                                                    popperModifiers={{
                                                        preventOverflow: { enabled: true, boundariesElement: 'viewport' },
                                                        flip: { enabled: true }
                                                    }}
                                                    minDate={this.state.sDate}
                                                    maxDate={new Date()}
                                                    ref={this.eDateRef}
                                                />
                                                <div className="date-icon" onClick={(e) => this.handleFocus(e, 'eDate')}>
                                                    <i className="zmdi zmdi-calendar-note"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="genera-apply-btn income-statement-history-apply">
                                            <Button variant="contained" className="greencolor jr-btn bg-teal text-white refresh-btn" onClick={(e) => this.ApplyDate()} >Apply</Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-9">
                            <div className="float-right">
                                <Button className="greencolor jr-btn bg-teal text-white refresh-btn view-btn" onClick={(e) => this.BackToReport()} >Back</Button>
                            </div>
                        </div>
                    </div>
                    {/* Page-level centred loader; the table mounts only once the
                        fetch has resolved. */}
                    {loading ?
                        <div className="is-loading-wrap income-statement-history-loader">
                            <CircularProgress />
                        </div>
                        :
                    <div className="row income-statement-history-table-row">
                        <div className="table-responsive income-statement-history-table-wrap">
                            <table className="table income-statement-history-table">
                                <thead>
                                    <tr className="header-bg-color archived_sheets">
                                        <th className="income-statement-history-col-details">Details</th>
                                        <th className="income-statement-history-col-date">Reviewed On</th>
                                        <th className="income-statement-history-col-user">Reviewed By</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        <React.Fragment>
                                            {historyList && historyList.length > 0 ?
                                                historyList.map((item, index) => (
                                                    <tr key={index}>
                                                        <td className="income-statement-history-col-details">
                                                            <Link
                                                                className="income-statement-history-link"
                                                                to={{
                                                                    pathname: '/reviewedIS',
                                                                    state: {
                                                                        ReviewedData: {
                                                                            ...item,
                                                                            reviewedId: item.id,
                                                                            companyId: item.companyId
                                                                        }
                                                                    }
                                                                }}
                                                            >
                                                                {item.details}
                                                            </Link>                                                        </td>
                                                        <td className="income-statement-history-col-date">{item.stReviewedDate}</td>
                                                        <td className="income-statement-history-col-user">{item.userName}</td>
                                                    </tr>
                                                ))
                                                :
                                                <tr>
                                                    <td colSpan="3" className="text-center income-statement-history-empty"> No Data Found </td>
                                                </tr>
                                            }
                                        </React.Fragment>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    }
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state) => ({
    MarkAsReviewedListData: state.IncomeStatement.MarkAsReviewedListData
});


const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        GetMarkAsReviewedHistoryList
    }, dispatch);
};


export default connect(mapStateToProps, mapDispatchToProps)(IncomeStatementReviewedHistoryList);
